var JoinDefaultView = Backbone.View.extend({
    el: '#joinDefaultContainer',
    initialize: function (options) {
        this.form = $('#joinDefaultForm');
        this.nick = $('#joinDefaultNick');
        this.name = $('#joinDefaultName');
        this.error = $('p#joinDefaultError');
        
        _.bindAll(this, 'focusNick');
        
        this.visible = false;
        this.disabled = false;
    },
    events: {
        'submit #joinDefaultForm': 'submitForm'
    },
    submitForm: function (e) {
        e.preventDefault();
        if (this.isDisabled()) {
            return;
        }
        this.hideError();
        var nick = this.nick.val();
        var realname = this.name.val();
        this.disableForm();
        this.model.joinDefault(nick, realname, _.bind(function (response) {
            this.enableForm();
            if (response.success) {
                this.hideError();
                this.model.setFocusOnMakeServer(response.cid);
            } else {
                var message;
                switch (response.message) {
                case 'nickname':
                    message = 'Invalid nickname';
                    break;
                default:
                    message = 'Error joining #feedback: ' + response.message;
                    break;
                }
                this.showError(message);
            }
        }, this));
    },
    hideError: function () {
        this.error.hide();
    },
    isDisabled: function () {
        return this.disabled;
    },
    disableForm: function () {
        if (!this.isDisabled()) {
            this.disabled = true;
            this.form.find('input, button, textarea').blur().prop('disabled', true);
        }
    },
    enableForm: function () {
        if (this.isDisabled()) {
            this.disabled = false;
            this.form.find('input, button, textarea').prop('disabled', false);
        }
    },
    showError: function (message) {
        this.error.text(message).fadeIn('fast');
    },
    isVisible: function () {
        return this.visible;
    },
    show: function () {
        if (this.isVisible()) {
            return;
        }
        this.name.val(this.model.get('name'));
        var nick = this.model.getNick();
        this.nick.val(nick);
        $(this.el).show();
        this.focusNick();
        this.visible = true;
    },
    hide: function () {
        if (!this.isVisible()) {
            return;
        }
        $(this.el).hide();
        this.hideError();
        this.visible = false;
    },
    focusNick: function () {
        this.nick.focus().select();
    }
});


module.exports = JoinDefaultView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/joindefaultview.js
// module id = nR5u
// module chunks = 1